<div class="chat-container">
    <!-- Chat List Section -->
    <div class="chat-sidebar" *ngIf="!isMobile || (!isChatSelected && isMobile)">
        <div class="sidebar-header">
            <div class="chat-tabs">
                <button class="chat-tab active">All <i class="bi bi-chevron-down"></i></button>
                <button class="chat-tab">Unread</button>
            </div>
        </div>
        <div class="search-bar">
            <input type="text" placeholder="Search Chat" />
        </div>
        <div class="chat-list">
            <div class="chat-item" *ngFor="let chat of chats" [class.active]="selectedChat === chat"
                (click)="selectChat(chat)">
                <img [src]="chat.avatar" alt="User Avatar" class="chat-avatar" />
                <div class="chat-info">
                    <p class="chat-name">{{ chat.name }}</p>
                    <p class="chat-preview">{{ chat.preview }}</p>
                </div>
                <div class="chat-meta">
                    <p class="chat-time">{{ chat.time }}</p>
                    <span *ngIf="chat.unread" class="chat-notification">{{ chat.unread }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Chat Area Section -->
    <div class="chat-area" *ngIf="!isMobile || (isChatSelected && isMobile)">
        <div class="chat-header">
            <button *ngIf="isMobile" class="back-button" (click)="goBack()">
                ←
            </button>
            <img *ngIf="selectedChat" [src]="selectedChat.avatar" alt="User Avatar" class="chat-avatar" />
            <div class="chat-user-info">
                <h3>{{ selectedChat?.name }}</h3>
                <p class="typing" *ngIf="selectedChat?.typing">Typing...</p>
            </div>
            <div *ngIf="selectedChat" class="chat-actions">
                <button class="icon-button">
                    <i class="icon bi bi-camera-fill"></i>
                </button>
                <button class="icon-button">
                    <i class="icon bi bi-telephone-fill"></i>
                </button>
                <button class="icon-button">
                    <i class="icon bi bi-three-dots"></i>
                </button>
            </div>
        </div>
        <div class="chat-messages" *ngIf="selectedChat">
            <p class="chat-date">Today</p>
            <div *ngFor="let message of selectedChat.messages" [ngClass]="message.type" class="message">
                <p class="message-text">{{ message.text }}</p>
                <span class="message-time">{{ message.time }}</span>
            </div>
        </div>
        <div class="message-input-area" *ngIf="selectedChat">
            <input [(ngModel)]="newMessage" placeholder="Type a message" />
            <button class="send-button" (click)="sendMessage()">Send</button>
        </div>
    </div>
</div>